import { render } from "./carSlide.vue?vue&type=template&id=155d8e8f&scoped=true"
import script from "./carSlide.vue?vue&type=script&lang=js"
export * from "./carSlide.vue?vue&type=script&lang=js"

import "./carSlide.vue?vue&type=style&index=0&id=155d8e8f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-155d8e8f"]])

export default __exports__